<template>
    <div>
        <div class="line-item">
            <div class="line-items">
                <div class="line-item-name" :class="{'narrow-element': narrowElement}">
                    {{ item.name }}

                    <div v-if="item.description" class="line-item-desc multi-line-description">{{ item.description }}</div> <!-- eslint-disable-line vue/singleline-html-element-content-newline -->

                    <div class="mobile-price">
                        <div class="preview">
                            {{ $t('InvoiceLineItem.mobileDescription', { quantity: item.quantity, price: $n(item.price, 'currency') }) }}
                        </div>
                    </div>
                </div>

                <div class="column-edit mobile-layout">
                    <div class="preview">
                        {{ $n(item.price, 'currency') }}
                    </div>
                </div>

                <div class="column-edit mobile-layout">
                    <div class="preview">
                        {{ item.quantity }}
                    </div>
                </div>

                <div v-if="hastaxes" class="column-edit mobile-layout preview sales-tax">
                    <ul>
                        <li
                            v-for="orderItemTax in item.orderItemTaxes"
                            :key="orderItemTax.name"
                            class="preview sales-tax"
                        >
                            {{ orderItemTax.name }} ({{ orderItemTax.rate }}%)
                        </li>
                    </ul>
                </div>

                <div class="column-edit total-summary">
                    <div class="total">
                        {{ $n(totalValue, 'currency') }}
                        <span v-if="recurring && item.billingCycle !== 0">{{ $t(`InvoiceLineItem.timeInterval.${item.billingCycle}`) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="item.description"
            class="mobile-description multi-line-description"
        >
            {{ item.description }}
        </div>

        <RecurringItemDescription
            v-if="recurring"
            :item="item"
            :contact="contact"
            :invoice-start-date="invoice.dueDate"
        />
    </div>
</template>

<script>
import invoiceLineItemsMixin from '../../mixins/invoice-line-items';
import RecurringItemDescription from '../RecurringItemDescription.vue';

export default {
    components: {
        RecurringItemDescription,
    },

    mixins: [invoiceLineItemsMixin],

    props: {
        contact: String,
        recurring: Boolean,
        item: Object,
        invoice: {
            type: Object,
            default: () => ({}),
        },
        narrowElement: Boolean,
        paidInvoice: Boolean,
    },

    computed: {
        totalValue() {
            return this.item.price * this.item.quantity;
        },

        endDate() {
            return this.invoiceLineItems_invoiceEndDate;
        },

        hastaxes() {
            return Boolean(this.invoice?.taxSummaryItems?.length > 0);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.line-item {
    padding: $spacing-050 $spacing-100;

    @media($small) {
        padding: $spacing-200 0 $spacing-100;
    }
}

.mobile-description,
.mobile-price {
    display: none;
}

.line-items {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    --input-margin-bottom: 0;
}

.line-item-desc {
    color: $color-ink-800;
    word-break: normal;
}

.multi-line-description {
    white-space: pre-wrap;
}

.line-item-name {
    display: flex;
    flex-direction: column;
    width: 40%;
    margin-top: $spacing-100;
    font-size: $font-size-md;
    padding-bottom: $spacing-150;

    @media($small) {
        width: 100%;
        padding: 0;
    }

    &.narrow-element {
        width: px-to-rem(198);
    }
}

.column-edit {
    display: flex;
    align-items: center;
    width: 10%;
    font-size: $font-size-md;
    font-family: $font-table-number;

    @media screen and (max-width: 800px) {
        margin: $spacing-200 $spacing-200 $spacing-250 $spacing-200;
    }

    @media($small) {
        width: auto;
    }

    &.mobile-layout {
        @media screen and (max-width: 800px) {
            display: none;
        }
    }

    @media print {
        display: flex;
        align-items: center;
        width: 35%;
        justify-items: flex-start;
    }
}

.total-summary {
    display: flex;
    font-size: $font-size-md;
    justify-content: flex-end;
    align-items: flex-end;

    @media($small) {
        padding-bottom: $spacing-200;
    }

    @media print {
        padding-bottom: 0;
    }
}

.preview {
    text-align: right;
    margin-bottom: $spacing-100;

    @media screen and (max-width: 800px) {
        font-size: $font-size-xs;
    }

    @media($small) {
        padding: 0;
        margin: 0;
    }

    .sales-tax {
        font-family: 'Sul Sans', Monaco, Courier, monospace;
        display: block;
    }
}

.total {
    display: flex;
    font-family: $font-table-number;
    justify-content: flex-end;
}

@media only screen and ($small) {
    .line-item-desc {
        display: none;
    }

    .mobile-description,
    .mobile-price {
        margin: $spacing-050 0;
        font-size: $font-size-xs;
        display: flex;
    }
}

@media print {
    .multi-line-description {
        font-size: $font-size-xs;
    }
}
</style>
